import { apiClient } from './client'
import { saveBlob } from '../lib/download'

/**
 * Dosya ekini kimlik-doğrulamalı olarak indirir. Ortak uç: {@code /management/attachments/{id}}.
 *
 * Düz {@code <a href>} navigasyonu OIDC yetkilendirme başlığını taşımadığından backend
 * {@code UNAUTHENTICATED} döner; bu yüzden içerik {@code apiClient} (interceptor başlığı ekler)
 * ile blob olarak çekilip
 * {@link saveBlob} ile kaydedilir (downloadMinutesPreviewPdf ile aynı desen).
 */
export async function downloadAttachment(id: number, fileName: string): Promise<void> {
  const { data } = await apiClient.get<Blob>(`/management/attachments/${id}`, {
    responseType: 'blob',
  })
  saveBlob(data, fileName)
}
